import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EDLGroupType, EdlPortalUserSearchCriteria, PagedResponse, User } from '@edl-development/edl-common';
import { SelectGroupService } from 'src/app/groups/common/services/select-group.service';
import { InComplianceStatus } from 'src/app/item-packets/common/enums/in-compliance-status.enum';
import { InComplianceReportRequest } from 'src/app/model/in-compliance-report-request.model';
import { EdlItemPacketEntryDTO } from 'src/app/model/item-packet/edl-item-packet-entry.model';
import { VolunteerReportHelperService } from 'src/app/services/volunteer/volunteer-report-helper.service';

@Component({
    selector: 'in-compliance-print-report',
    templateUrl: './in-compliance-print-report.component.html',
    styleUrls: ['./in-compliance-print-report.component.scss']
})
export class InCompliancePrintReportComponent {
    @Input() searchCriteria: EdlPortalUserSearchCriteria;
    @Input() request: InComplianceReportRequest;
    @Input() user: User;
    @Input() pagedResponse: PagedResponse;
    @Input() itemPackets: EdlItemPacketEntryDTO[] = [];

    EDLGroupType = EDLGroupType;
    form: UntypedFormGroup;

    constructor(
        public volunteerReportHelperService: VolunteerReportHelperService,
        private selectGroupService: SelectGroupService
    ) { }

    getItemPacketLabel(): string {
        return this.itemPackets.find((packet: EdlItemPacketEntryDTO) => packet.Id === this.request.ItemPacketId)?.Title ?? 'No Item Packet Selected';
    }

    getVolunteerAreasLabel(): string {
        let volunteerAreas = this.selectGroupService.toGroupsSelectForm({ selectedGroupIds: this.request.VolunteerAreaIds, searchCriteria: this.searchCriteria, filterGroupType: EDLGroupType.VOLUNTEER_AREA });
        return Object.values(volunteerAreas.value)
            .map((entry: any) => entry?.details?.GroupName)
            .filter((name: string | undefined) => !!name)
            .join(', ') || 'Any Volunteer Areas';
    }

    getSearchCriteria(): string {
        return this.request.SearchBy?.trim() ? this.request.SearchBy : 'No Search Criteria';
    }

    getItemPacket(itemPacketId?: string): EdlItemPacketEntryDTO | undefined {
        return this.itemPackets.find((packet: EdlItemPacketEntryDTO) => packet.Id === itemPacketId) || undefined;
    }

    getInComplianceStatus(isInCompliance: boolean) {
        return isInCompliance ? InComplianceStatus.IN_COMPLIANCE : InComplianceStatus.OUT_OF_COMPLIANCE;
    }
}
